import { useContext } from 'react'

import { FilterHeader } from '../../../FilterModal'
import { ADD_ROOM } from '../../Constants'
import { PaxAlertRenderer } from './PaxAlertRenderer'
import { PAXContext } from './PaxContext'

export default function PaxAlert() {
	let [
		{
			enableRoomAdition = true,
			errorResponse = '',
			isError = false,
			totalPax,
			isInfantExceed,
		},
		dispatch,
	] = useContext(PAXContext)
	errorResponse = errorResponse
		? errorResponse
		: totalPax >= 9
		? 'Max 9 people allowed in a trip'
		: ''
	if (!errorResponse) {
		return null
	}
	return (
		<FilterHeader>
			<PaxAlertRenderer
				alertContent={errorResponse}
				links={
					enableRoomAdition && !isInfantExceed
						? [
								{
									text: '+ Add room',
									clickAction: () => {
										if (!isError) {
											dispatch({
												type: ADD_ROOM,
												payload: {
													adultCount: 1,
													childAges: [],
												},
											})
										}
									},
								},
						  ]
						: []
				}
			/>
		</FilterHeader>
	)
}
